/**
 2  * @desc 函数防抖
 3  * @param fn 函数
 4  * @param timerDelay 延迟执行毫秒数
 5  * @param immediate true 表立即执行，false 表非立即执行
 6  */
export function debounce(fn, timerDelay, immediate) {
    let timer
    return function () {
        const that = this
        const args = arguments

        if (timer) clearTimeout(timer)
        if (immediate) {
            var callNow = !timer
            timer = setTimeout(() => {
                timer = null
            }, timerDelay)
            if (callNow) fn.apply(that, args)
        } else {
            timer = setTimeout(function () {
                fn.apply(that, args)
            }, timerDelay)
        }
    }
}

export function getCodeFromUrl() {
  return new URLSearchParams(window.location.search).get('code')
}
